//REACT
import React from "react";
import PersonAdd from "@material-ui/icons/PersonAdd";
//Secciones
import Cabecera from "../CabeceraPie/Cabecera";
import PiePagina from "../CabeceraPie/PiePagina";

import Carrusel from "pages/Home/sections/Carrusel";
import NavPills from "components/NavPills/NavPills";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import Button from "components/CustomButtons/Button";
import { Person } from "@material-ui/icons";
import { ModalSimple } from "components/Modal/confirm-modal/firma-simple/modal-simple";
import { ModalAvanzado } from "components/Modal/confirm-modal/firma-avanzada/modal-avanzado";
import { useModalAd } from "components/Modal/confirm-modal/firma-avanzada/modal-avanzado";
import { useModalSimple } from "components/Modal/confirm-modal/firma-simple/modal-simple";

export default function IndexHome() {
  const { showAdModal, onCloseAdModal, onShowAdModal } = useModalAd();
  const { showSignModal, onCloseSignModal, onShowSignModal } = useModalSimple();
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    window.localStorage.clear();
    window.sessionStorage.clear();
  });

  return (
    <div>
      <Cabecera color="transparent" />
      <Carrusel />
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={6}>
          <NavPills
            alignCenter
            color="primary"
            tabs={[
              {
                tabButton: "Firma Simple",
                tabIcon: Person,
                tabContent: (
                  <Card style={{ padding: "20px" }}>
                    <span>
                      <p>
                        En Firmadox queremos que su emprendimiento pueda acceder
                        a el mundo de la factura electrónica al menor costo
                        posible y de la manera más rápida, ya estamos
                        acreditados por el S.I.I para entregar firmas
                        electrónicas de uso tributario, con ella podrá facturar
                        electrónicamente a través del sitio web del S.I.I.
                      </p>
                    </span>
                    <div style={{ float: "left", paddingRight: 80 }}>
                      <Button color="primary" onClick={onShowSignModal} style={{ borderRadius: 30 }}>
                        COMPRAR
                      </Button>
                    </div>
                  </Card>
                ),
              },
              {
                tabButton: "Firma Avanzada",
                tabIcon: PersonAdd,
                tabContent: (
                  <Card style={{ padding: "20px" }}>
                    <span>
                      <p>
                        Nuestra firma electrónica avanzada está acreditada según
                        la resolución exenta N° RAEX202200985, del 26 de mayo de
                        2022, de la Subsecretaría de Economía y Empresas de
                        Menor Tamaño. Con ella podrá tener la confianza de que
                        su firma electrónica avanzada cumple con los más altos
                        estándares de seguridad. Firme electrónicamente
                        contratos, documentos, etc. Consulte por nuestros
                        servicios de gestión documental asociados al uso de la
                        firma electrónica.
                      </p>
                    </span>
                    <div style={{ float: "left", paddingRight: 80 }}>
                      <Button color="primary" onClick={onShowAdModal} style={{ borderRadius: 30 }}>
                        COMPRAR
                      </Button>
                    </div>
                  </Card>
                ),
              },
            ]}
          />
        </GridItem>
      </GridContainer>
      <PiePagina />
      <ModalSimple
        showSignModal={showSignModal}
        onCloseSignModal={onCloseSignModal}
      />
      <ModalAvanzado
        showAdModal={showAdModal}
        onCloseAdModal={onCloseAdModal}
      />
    </div>
  );
}
